<template>
  <v-card
    class="mx-auto pt-5 EK-card rounded-xl rounded-tl-0 IMThemeGray store-action-form"
  >
    <v-card-title class="justify-content-center py-3 IMThemeOrange rounded-0 text-white">
      <strong v-if="orderDto.orderType == 2">تعديل بيانات</strong>
      <strong v-else-if="orderDto.orderType == 4">شكوى/اقتراح</strong>
    </v-card-title>
    <v-card-text class="text-right pt-4">
      <div>
        <v-textarea
          color="secondary"
          id="description"
          rounded
          readonly
          solo
          v-model="orderDto.description"
        ></v-textarea>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        class="mx-auto px-8"
        @click="onConfirmDelete(orderDto.id, orderIndex)"
        rounded
      >
        حذف
        <img src="/media/svg/table/delete.svg" alt="delete" class="pr-2" />
      </v-btn>
    </v-card-actions>
    <v-card-actions>
      <v-btn
        @click="isShowSMS()"
        dark
        color="IMThemeOrange"
        rounded
        class="rounded-tl-0 px-6 mx-auto"
      >
        إرسال رسالة SMS
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="showSMS" width="1000px">
      <orderHandlerModal :smsDto="orderDto.smsDto" @close="isShowSMS()" />
    </v-dialog>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import orderHandlerModal from "@/components/orderHandlerModal.vue";
export default {
  props: {
    orderIndex: String,
  },
  components: {
    orderHandlerModal,
  },
  data: () => ({
    showSMS: false,
  }),
  computed: {
    ...mapGetters(["orderDto"]),
  },
  created() {
    this.getOrderDetails(this.orderIndex);
    this.offset = this.getOffset(document.querySelector(".store-action-form")).top;
    setTimeout(() => {
      window.scrollTo(this.offset, this.offset);
    }, 100);
  },
  methods: {
    getOffset(el) {
      var _x = 0;
      var _y = 0;
      while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
      }
      return { top: _y, left: _x };
    },
    ...mapActions(["deleteOrdersStore", "getOrderDetails"]),
    onConfirmDelete(id, index) {
      this.deleteOrdersStore({ id, index });
    },
    isShowSMS() {
      this.showSMS = !this.showSMS;
    },
  },
  watch: {
    orderIndex(index) {
      this.getOrderDetails(index);
      this.offset = this.getOffset(document.querySelector(".store-action-form")).top;
      setTimeout(() => {
        window.scrollTo(this.offset, this.offset);
      }, 100);
    },
  },
};
</script>
